import http from "./httpService";

const apiEndpoint = "/users";

export default function register(user) {
  return http.post(apiEndpoint, {
    password: user.password,
    name: user.username
  });
}